// extracted by mini-css-extract-plugin
export default {"top":"Footer_top__Ua30g","footer":"Footer_footer__TL9Uz"};